import classNames from 'classnames';
import React, { ReactElement } from 'react';
import styles from './index.module.css';

export type ActionsBarLeftTabProps = {
  ariaLabel: string;
  isActiveTab: boolean;
  label: string;
  onClick: VoidFunction;
};

export const ActionsBarLeftTab = ({
  ariaLabel,
  isActiveTab,
  label,
  onClick,
}: ActionsBarLeftTabProps): ReactElement => {
  const classes = classNames(
    { [styles.sessionViewTabSelected]: isActiveTab },
    styles.sessionViewTab,
  );

  return (
    <button aria-label={ariaLabel} className={classes} onClick={onClick}>
      {label}
    </button>
  );
};
